// src/supabaseClient.js

import { createClient } from '@supabase/supabase-js';

// Initialize the Supabase client with environment variables
// In React, environment variables must be prefixed with REACT_APP_
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_KEY;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  console.error('Missing Supabase environment variables. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_KEY');
}

export const supabase = createClient(SUPABASE_URL || '', SUPABASE_KEY || '');
